import { Box } from '@mui/material';
import React from 'react';
import { Group, Panel, Separator } from 'react-resizable-panels';

import useStyles from './ResizablePanel.styles';
import type { ResizablePanelProps } from './ResizablePanel.types';

const ResizablePanel = ({
  sizes = [],
  panels = [],
  panelGroupKey
}: ResizablePanelProps) => {
  const { classes } = useStyles();

  const [dragging, setDragging] = React.useState(false);

  return (
    <Group
      key={panelGroupKey}
      onLayoutChange={() => {
        setDragging(true);
      }}
      onLayoutChanged={() => {
        setDragging(false);
      }}
      orientation="horizontal"
    >
      {panels.map((panel, index) => (
        <React.Fragment key={panel.id}>
          <Panel
            collapsible
            id={panel.id}
            defaultSize={sizes[index]}
            minSize={panel.minSize}
            maxSize={panel.maxSize}
          >
            {panel.content}
          </Panel>

          {panel.showResizeHandle && index < panels.length - 1 && (
            <Separator
              className={classes.panelResizeHandleContainer}
              style={{
                // Hide handle visually when next panel is collapsed (maxSize 0)
                pointerEvents:
                  panels[index + 1]?.maxSize === '0%' ? 'none' : 'auto',
                opacity: panels[index + 1]?.maxSize === '0%' ? 0 : 1
              }}
            >
              {dragging && <Box className={classes.panelResizeHandle} />}
              {!dragging && (
                <Box className={classes.panelResizeHandle2}>
                  <Box className={classes.panelResizeHandle2Inner} />
                  <Box className={classes.panelResizeHandle2Inner} />
                  <Box className={classes.panelResizeHandle2Inner} />
                </Box>
              )}
            </Separator>
          )}
        </React.Fragment>
      ))}
    </Group>
  );
};

export default ResizablePanel;
